import { useAppSelector } from 'modules/hooks/appHooks';
import { useLocationCodes } from 'modules/hooks/codesHooks/useLocationCodes';
import { LoginSelectors } from 'modules/landingPage/components/login/redux';
import { InputWithLabel, SelectWithLabel } from 'modules/ui';
import { FormContainer } from 'modules/ui/form';
import { DatePicker } from 'modules/ui/input';
import { concatAreaCodeAndNumber } from 'modules/utils';
import { useTranslation } from 'react-i18next';
import { EntityTypeCodes } from '../helper';

export const ViewProfileForm: React.FC = () => {
  const { t } = useTranslation();

  const user = useAppSelector(LoginSelectors.selectUser);
  const { countryOptions, cityAndZipCodeOptions } = useLocationCodes();

  return (
    <FormContainer width="30rem">
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.partnerName')}
        defaultValue={user?.partnerName}
      />
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.oib')}
        defaultValue={user?.oib}
      />
      <SelectWithLabel
        readOnly
        label={t('profilePage.informationOverview.country')}
        defaultValue={user?.country}
        options={countryOptions}
      />
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.street')}
        defaultValue={user?.street}
      />
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.houseNumber')}
        defaultValue={user?.houseNumber}
      />
      <SelectWithLabel
        readOnly
        label={t('profilePage.informationOverview.city')}
        defaultValue={user?.postalCode}
        options={cityAndZipCodeOptions}
      />
      <SelectWithLabel
        readOnly
        label={t('profilePage.informationOverview.shippingCountry')}
        defaultValue={user?.shippingCountry}
        options={countryOptions}
      />
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.shippingStreet')}
        defaultValue={user?.shippingStreet}
      />
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.shippingHouseNumber')}
        defaultValue={user?.shippingHouseNumber}
      />
      <SelectWithLabel
        readOnly
        label={t('profilePage.informationOverview.shippingCity')}
        defaultValue={user?.shippingPostalCode}
        options={cityAndZipCodeOptions}
      />
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.phone')}
        defaultValue={concatAreaCodeAndNumber(user?.phone)}
      />
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.email')}
        defaultValue={user?.email}
      />
      <DatePicker
        readOnly
        disabled
        label={t('profilePage.informationOverview.birthDate')}
        defaultValue={user?.birthDate}
      />
      <InputWithLabel
        readOnly
        label={t('profilePage.informationOverview.birthPlaceName')}
        defaultValue={user?.birthPlaceName}
      />
      <SelectWithLabel
        readOnly
        label={t('profilePage.informationOverview.birthCountry')}
        defaultValue={user?.birthCountry}
        options={countryOptions}
      />
      {user?.entityTypeCode !== EntityTypeCodes.PhysicalEntity ? (
        <>
          <InputWithLabel
            readOnly
            label={t('profilePage.informationOverview.contactPerson')}
            defaultValue={user?.contactPersonName}
          />
          <InputWithLabel
            readOnly
            label={t('profilePage.informationOverview.contactPhone')}
            defaultValue={concatAreaCodeAndNumber(user?.contactPersonPhone)}
          />
        </>
      ) : (
        <></>
      )}
    </FormContainer>
  );
};
